<template>
  <div class="aPhoneInput field">
    <label  :for="fieldname">{{label}} <span v-if="isRequired" class="req" tabindex="-1">*</span></label>
    <div class="inputwrapper">
      <input
      ref="phone"
      type="tel"
      v-model="phoneNumber"
      :placeholder="placeholder"
      :disabled="disabled"
      :id="fieldname"
      :class="{hasError: isInError, hasSuccess: isInSuccess, isLoading: isLoading}"
      @countrychange="sendInternationalFormat"
      tabindex="0">
      <icons-svg icon="cadenas" class="smallfieldicon" v-if="isDisabled" aria-hidden="true"></icons-svg>
    </div>
    <div class="errorMessage" v-if="isInError" tabindex="0"><ul v-html="errorMessage"></ul></div>
    <div class="helper" :class="fieldname + '-helper'" v-html="helper" role="note" :aria-label="helper"></div>
  </div>
</template>

<!-- ================================================================================== -->

<script>
 import 'intl-tel-input/build/css/intlTelInput.css';
 import intlTelInput from 'intl-tel-input';
 import FormFields from "../mixins/FormFields";
 import IconsSvg from '@/components/IconsSvg';
 import {debounce} from "lodash";
 import config from "../config";
 import customLog from "../mixins/CustomLog";
 export default {
  name: "PhoneInput",
  mixins: [FormFields, customLog],
  components: {
    IconsSvg,
  },
  props: {
    fieldname: {
      type: String,
      required: true
    },
    modelValue: {
      required: true,
      type: String
    },
    initialCountry: {
      required: false,
      type: String,
      default: 'be'
    },
    preferredCountries: {
      required: false,
      type: Array,
    default: () => [/* "be", "lu", "nl" */]
    },
    countries: {
      required: true,
      type: Array,
      default: () => [ "al", "ad", "at", "by", "be", "ba", "bg", "hr", "cz", "dk",
        "ee", "fo", "fi", "fr", "de", "gi", "gr", "va", "hu", "is", "ie", "it", "lv",
        "li", "lt", "lu", "mk", "mt", "md", "mc", "me", "nl", "no", "pl", "pt", "ro",
        "ru", "sm", "rs", "sk", "si", "es", "se", "ch", "ua", "gb" ]

      },
      label : {
        type: String,
        required : true
      },
      receivedNumber: {
        type: String,
        required: false,
      },
      isDisabled : {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        phonejs: '',
        config: config,
        disabled: false,
        errorMessage: null,
      }
    },


    methods: {

      sendInternationalFormat() {
        this.log("sendInternationalFormat", 'function');
        let phoneToEmit = this.phonejs.getNumber();
        this.log(`phoneToEmit: ${phoneToEmit}`, 'low');
        this.$emit('internationalNumber', phoneToEmit);
      },

      lockThisField(bool) {
        this.disabled = bool;
      },

      validateMyself() {
        this.setLoading();
      /* ! This won't work if not configured in the LEAD, returning a non-managed error (see comment below) */
        let data = {
          [this.fieldname]: this.phonejs.getNumber()
        }
        this.axios.post(`/lead/${config.idlead}/data/${this.fieldname}/validate`, data)
        .then(() => {
          this.giveSuccess();
          this.$emit('runCheck', {fieldname: this.fieldname, valid: true});
          this.setNotLoading();
        }).catch(error => {
          if(error.response.status === 503){
            this.setNotLoading();
            this.$emit('maintenanceDetected');
          }else{
            try{
             if(error.response.data.errorsKeyed){
              let combinedList = Object.values(error.response.data.errorsKeyed).flat();
              this.errorMessage = this.createAnHtmlListFromErrors(combinedList);
            }
          }catch(e){
            console.log("An error occured");
            console.error(e);
          }
          this.giveError();
          this.setNotLoading();
          this.$emit('runCheck', {fieldname: this.fieldname, valid: false}); 
        }
      })
      },

      createAnHtmlListFromErrors(errorsList){
        let html = "";
        errorsList.forEach(err => {
          html += `<li>${err.message}</li>`;
        });
        return html;
      },

    },
    computed: {
      phoneNumber: {
        get: function () {
          return this.modelValue;
        },
        set: function (newval) {
          this.validateMyselfDebounced();
          this.$emit('update:modelValue', newval);
          this.sendInternationalFormat();
        }
      },
    },

    mounted() {
      this.phonejs = intlTelInput(this.$refs.phone, {
        initialCountry: this.initialCountry,
        autoHideDialCode: false,
        utilsScript: require('intl-tel-input/build/js/utils'),
        onlyCountries: this.countries,
        preferredCountries: this.preferredCountries,
        nationalMode: true,
        customContainer: "fullwidth",
        allowDropdown: false,
        autoInsertDialCode: true,
        separateDialCode: false,
    showFlags: false, // Does not work in this version? -updating node dependencies is a nightmare this day (oct 2023).
  });

      this.validateMyselfDebounced = debounce(this.validateMyself, 1000);
      // run validation immediately when the value is not null or empty
      if(this.phoneNumber) {
        this.validateMyselfDebounced();
        this.sendInternationalFormat();
      }

      // If a phone number is received from From.vue, display it.
      if(this.receivedNumber && this.receivedNumber.length > 0){
        this.log(`Phone field received a String: ${this.receivedNumber}`, 'low');
        // if phone is set programmatically, I must get it from the field, not just from the var (race condition)
        this.$refs.phone.value = this.receivedNumber;
        this.phonejs.setNumber(this.receivedNumber);
        this.phoneNumber = this.receivedNumber;
        this.sendInternationalFormat();
      }
    },
  }
</script>

<!-- ================================================================================== -->

<style lang="scss" scoped>

</style>
